import React from 'react'
import PropTypes from 'prop-types'
import Style from './style'
import { IMG } from '../../themes'

const defaultFunction = () => {}

class UserBadge extends React.Component {
  renderCloseButton () {
    return (
      <button className='close-button' onClick={(event) => this.props.handleCloseButton(event)}>
        <svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='times' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 352 512'><path fill='currentColor' d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z' /></svg>
      </button>
    )
  }

  render () {
    const props = Object.assign({}, this.props)
    return (
      <Style>
        <div className='badge-container jump-in' onClick={props.handleClick ? (event) => props.handleClick(event) : defaultFunction} index={props.index}>
          <figure>
            <img
              src={props.image ? props.image : IMG['user-tie-solid.svg']}
              alt={"user's avatar"}
              onError={(event) => { event.target.src = IMG['user-tie-solid.svg'] }}
            />
          </figure>
          <section className='name-container'>
            <h1 className='user-name'>{props.name ? props.name : props.username}</h1>
            <label className='user-username'>{props.name ? props.username : null}</label>
          </section>
          {(props.showButton) ? this.renderCloseButton() : null}
        </div>
      </Style>
    )
  }
}

UserBadge.propTypes = {
  handleCloseButton: PropTypes.func,
  handleClick: PropTypes.func,
  name: PropTypes.string,
  username: PropTypes.string.isRequired,
  showButton: PropTypes.bool,
  image: PropTypes.string
}

export default UserBadge
